import { render } from "./adding-new-utilities.md?vue&type=template&id=3dbf9c48"
const script = {}
script.render = render

export default script